
export const About = () => {

    const text = `גדלתי למטבח העיראקי והאשכנזי בבית הורי, התחתנתי ולמדתי מחמותי את סודות הבישול המרוקאים. לאורך 20 שנה בישלתי ואפיתי לילדים ולמשפחות במסגרת משפחתון שניהלתי. 

    בשנים האחרונות אני מכינה מגוון רחב של אוכל ביתי, ישראלי ואיכותי ועושה זאת מכל הלב ובהשקעה רבה.
    בתפריט הבישול שלי תמצאו מגוון מנות כשרות בשריות, צמחוניות וטבעוניות שיצאו היישר מהמטבח הביתי שלי אליכם הביתה.
    
    חשוב לי להדגיש שכל מנה שיוצאת מהמטבח שלי מגיעה אליכם עוד באותו היום על מנת לשמור על טריות ואיכות המנות. לכן, ניתן לבצע הזמנה לפחות יום מראש ורצוי כמה ימים לפני.
    
    אני מזמינה אתכם להיכנס לעמוד שלנו באינסטגרם, בפייסבוק ולצפות בתפריט שלנו באתר`;
    return (
        <section className="about main-layout full ">
            <article className="about-hero  full "></article>
            <section className="text-container">
                <section className="text">
                    <h1>המטבח של טלי נעים להכיר</h1>
                    <div className="hebrew-text">
                        {text.split('\n').map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>
                    <p>תעיינו, תתגרו ותתקשרו להזמין. השאר עלינו😉 </p>
                    <p>בהזמנות מעל 10 מנות נא לבצע הזמנה של שבוע מראש</p>
                    <p>*ניתן ליצור קשר בווצאפ או בטלפון: 052-8011016</p>
                    <p>שיהיה בתאבון!</p>
                </section>
            </section>
            <section className="img-grid">
                <img loading='lazy' alt="food" src={require('../assets/imgs/img1.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img2.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img3.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img4.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img5.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img6.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img7.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img8.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img9.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img10.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img11.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img13.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img14.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img15.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img18.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img19.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img20.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img21.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img25.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img26.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img27.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img28.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img29.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img30.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img31.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img32.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img33.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img34.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img35.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img36.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img37.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img38.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img39.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img40.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img41.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img42.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img43.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img44.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img45.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img46.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img47.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img48.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img49.jpeg')} />
                <img loading='lazy' alt="food" src={require('../assets/imgs/img50.jpeg')} />
            </section>
        </section>
    );
};